import classes from "./Database.module.css"
import gearHead from "../../assets/json/parameters/GearInfoHead.json"
import gearClothes from "../../assets/json/parameters/GearInfoClothes.json"
import gearShoes from "../../assets/json/parameters/GearInfoShoes.json"
import { getSkillName, getName, skillImage, brandImage, gearImage } from "../../Utils"
import { useTranslation } from "react-i18next"

const Gear = props => {
    const { t } = useTranslation()

    const langList =
        props.type === 0
            ? "CommonMsg.Gear.GearName_Head"
            : props.type === 1
            ? "CommonMsg.Gear.GearName_Clothes"
            : "CommonMsg.Gear.GearName_Shoes"
    const gearList = props.type === 0 ? gearHead : props.type === 1 ? gearClothes : gearShoes
    const pgear = gearList.filter(elem => elem.Id === props.gear_id)
    if (pgear.length === 0) {
        return null
    }
    const gear = pgear[0]
    return (
        <div
            className={classes.Card}
            onClick={() =>
                props.onClick(props.gear_id, props.type, props.main, props.history, props.historyDrinks, props.seed)
            }
        >
            <div className={classes.CardDark}>
                <div className={classes.CardContent}>{getName(t, langList, gear)}</div>
                <div className={classes.TopRow}>
                    <img src={gearImage(gear.__RowId)} alt={gear.__RowId} className={classes.Gear} />
                    <img src={brandImage(gear.Brand)} alt={gear.Brand} className={classes.Brand} />
                </div>
                <div className={classes.Main}>
                    <img src={skillImage(getSkillName(props.main))} alt={props.main} className={classes.abilityImage} />
                </div>
                <div className={classes.Subs}>
                    {[...[255, 255, 255], ...props.history.filter(elem => elem >= 0)].slice(-3).map((elem, idx) => (
                        <div key={idx} className={classes.SubAbility}>
                            <img src={skillImage(getSkillName(elem))} alt={elem} className={classes.abilityImage} />
                        </div>
                    ))}
                </div>
                <div className={classes.CardContent}>{`0x${(props.seed >>> 0).toString(16)}`}</div>
            </div>
        </div>
    )
}

export default Gear
